/** @format */

import React from 'react'

import { DevelopMenu, Icon } from 'components'

import styles from './sidebar.module.css'

export const Sidebar = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.overlay}>
        <div className={styles.top}>
          <Icon name="logo" style={styles.icon} />
        </div>
        <DevelopMenu />
      </div>
    </div>
  )
}
